import { useQuery } from '@tanstack/react-query';
import { zohoApi } from '../services/api';

export function useZohoItems() {
  return useQuery({
    queryKey: ['zoho-items'],
    queryFn: () => zohoApi.items(),
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
  });
}
